import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs } from "@air/component-breadcrumbs";
import isEqual from "lodash/isEqual";
import { memo, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { BOARD_CRUMBS } from "~/constants/testIDs";
import { centralizedBoardAncestorsSelector, CentralizedBoardSelectors, centralizedBoardTitleSelector } from "~/store/centralizedBoard/selectors";
import { useGoToPublicBoard } from "~/swr-hooks/boards/useGoToPublicBoard";
export const PublicBoardHeaderAncestors = /*#__PURE__*/ memo(()=>{
    const ancestors = useSelector(centralizedBoardAncestorsSelector, isEqual);
    const id = useSelector(CentralizedBoardSelectors.boardId);
    const title = useSelector(centralizedBoardTitleSelector);
    const { goToPublicBoard } = useGoToPublicBoard();
    const onBoardClick = useCallback((locationBoard)=>{
        goToPublicBoard(locationBoard, "breadcrumb");
    }, [
        goToPublicBoard
    ]);
    const breadcrumbItems = useMemo(()=>{
        const items = [];
        ancestors === null || ancestors === void 0 ? void 0 : ancestors.map((ancestor)=>items.push({
                id: ancestor.id,
                label: ancestor.title,
                className: "max-w-[170px]",
                onClick: ()=>onBoardClick({
                        id: ancestor.id,
                        title: ancestor.title
                    }),
                type: "button"
            }));
        if (id && title) {
            items.push({
                id,
                className: "max-w-[350px]",
                label: title,
                type: "item"
            });
        }
        return items;
    }, [
        ancestors,
        id,
        onBoardClick,
        title
    ]);
    if (breadcrumbItems.length < 2) return null;
    return /*#__PURE__*/ _jsx(Breadcrumbs, {
        visibleItemsAtEnd: 2,
        className: "-ml-1",
        "data-testid": BOARD_CRUMBS,
        isCompact: breadcrumbItems.length > 4,
        items: breadcrumbItems
    });
});
PublicBoardHeaderAncestors.displayName = "PublicBoardHeaderAncestors";
